import { z } from "zod";
import { Id } from "./workspace.entity.ts";

export const ReadRevolutConnectionsInput = z.object({ orgId: Id }).strict();
export type ReadRevolutConnectionsInput = z.infer<
	typeof ReadRevolutConnectionsInput
>;

// Availability means this deployment has an application registration, not that
// Revolut has approved Pro access. Connected is proved by the stored credential
// initialization and excludes an authorization known to require fresh consent.
export const RevolutConnectionStatusSchema = z
	.object({
		available: z.boolean(),
		connected: z.boolean(),
		reconnectRequired: z.boolean(),
	})
	.strict()
	.refine((status) => !(status.connected && status.reconnectRequired), {
		path: ["connected"],
		message: "an authorization requiring fresh consent is not connected",
	});
export type RevolutConnectionStatus = z.infer<
	typeof RevolutConnectionStatusSchema
>;

export const ReadRevolutConnectionsOutput = z
	.object({
		sandbox: RevolutConnectionStatusSchema,
		live: RevolutConnectionStatusSchema,
	})
	.strict();
export type ReadRevolutConnectionsOutput = z.infer<
	typeof ReadRevolutConnectionsOutput
>;
